import { Card, Button } from "react-bootstrap";
import OpenLoanTenderingCase from "./OpenLoanTenderingCase";
import CloseLoanTenderingCase from "./CloseLoanTenderingCase";
import TendersHeading from "./TendersHeading";
import DontTenderTenderingCases from "./DontTenderTenderingCases";
import { useEffect, useState } from "react";
import TenderServices from "../../services/services/TenderServices";
import {
  ConfigProvider,
  DatePicker,
  Form,
  Input,
  message,
  Modal,
  Select,
  Spin,
} from "antd";
import moment from "moment";
import { useIntl } from "react-intl";
import { convertToObjectKeyString, TranslateString } from "Utils/Common";
import { TenderEditStatus } from "constants/Constants";
import localeFI from "antd/lib/locale/fi_FI";
import localeEN from "antd/lib/locale/en_US";
import "moment/locale/fi";
import UserService from "services/UserService";
import HousingCompanyService from "services/services/HousingCompanyService";
import { ExclamationCircleFilled } from "@ant-design/icons";
import Cookies from "universal-cookie";

function Tenders(props: any) {
  const cookies = new Cookies();
  // cookies for storing filters
  const openCookies = cookies.get("tenders-open-filters") || {};
  const closeCookies = cookies.get("tenders-close-filters") || {};
  const dontCookies = cookies.get("tenders-dont-filters") || {};
  const intl = useIntl();
  const [loading, setLoading] = useState<boolean>(false);
  const [tenderData, setTenderData] = useState<any>();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [openSort, setOpenSort] = useState(false);
  const [closeSort, setCloseSort] = useState(false);
  const [dontSort, setDontSort] = useState(false);
  const [openPageData, setOpenPageData] = useState({
    page: 0,
    size: 50,
  });
  const [openTotalRecords, setOpenTotalRecords] = useState(0);
  const [openTotalPages, setOpenTotalPages] = useState(0);
  const [closePageData, setClosePageData] = useState({
    page: 0,
    size: 50,
  });
  const [closeTotalRecords, setCloseTotalRecords] = useState(0);
  const [closeTotalPages, setCloseTotalPages] = useState(0);
  const [dontPageData, setDontPageData] = useState({
    page: 0,
    size: 50,
  });

  const [dontTotalRecords, setDontTotalRecords] = useState(0);
  const [dontTotalPages, setDontTotalPages] = useState(0);
  const [editValue, setEditValue] = useState<any>();
  const [revertData, setRevertData] = useState<any>();
  const [openSearchData, setOpenSearchData] = useState<any>({
    loan_data_priority: "",
    loan_data_customerid: "",
    loan_data_customername: "",
    loan_data_name: "",
    loan_data_loan_value: "",
    loan_data_margin: "",
    loan_data_bank_group: "",
    loan_tender_status: "",
    loan_tender_deadline: "",
    loan_tender_notes: "",
    cust_data_city: "",
    status: "",
    loan_tender_id: "",
    cust_data_manager_name: "",
    hm_comment: "",
    loan_data_agreement: "",
    accountant_name: "",
    created_by: "",
    sort: "asc",
    sort_by: "",
    ...openCookies,
  });
  const [closeSearchData, setCloseSearchData] = useState<any>({
    loan_data_priority: "",
    loan_data_customerid: "",
    loan_data_customername: "",
    loan_data_name: "",
    loan_data_loan_value: "",
    loan_data_margin: "",
    loan_data_bank_group: "",
    loan_tender_status: "",
    loan_tender_deadline: "",
    loan_tender_notes: "",
    cust_data_city: "",
    status: "",
    loan_tender_id: "",
    cust_data_manager_name: "",
    hm_comment: "",
    loan_data_agreement: "",
    accountant_name: "",
    created_by: "",
    sort: "asc",
    sort_by: "",
    ...closeCookies,
  });
  const [dontSearchData, setDontSearchData] = useState<any>({
    loan_data_priority: "",
    loan_data_customerid: "",
    loan_data_customername: "",
    loan_data_name: "",
    loan_data_loan_value: "",
    loan_data_margin: "",
    loan_data_bank_group: "",
    loan_tender_status: "",
    loan_tender_deadline: "",
    loan_tender_notes: "",
    cust_data_city: "",
    status: "",
    loan_tender_id: "",
    cust_data_manager_name: "",
    hm_comment: "",
    loan_data_agreement: "",
    accountant_name: "",
    created_by: "",
    sort: "asc",
    sort_by: "",
    ...dontCookies,
  });
  const [deadlineRequired, setDeadlineRequired] = useState(false);
  const [notesRequired, setNotesRequired] = useState(false);
  const [reTenderData, setReTenderData] = useState<any>();
  const [reTenderModalOpen, setReTenderModalOpen] = useState(false);

  useEffect(() => {
    getAllData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSearchData, closeSearchData, dontSearchData,openPageData,closePageData,dontPageData,]);

  //   const getAllData = async () => {
  //     setLoading(true);
  //     let object1: any = {};
  //     object1.loan_data_priority = openSearchData?.loan_data_priority;
  //     object1.loan_data_customerid = openSearchData?.loan_data_customerid;
  //     object1.loan_data_agreement = openSearchData?.loan_data_agreement;
  //     object1.loan_data_customername = openSearchData?.loan_data_customername;
  //     object1.loan_data_name = openSearchData?.loan_data_name;
  //     object1.loan_data_loan_value = openSearchData?.loan_data_loan_value;
  //     object1.loan_data_margin = openSearchData?.loan_data_margin;
  //     object1.loan_data_bank_group = openSearchData?.loan_data_bank_group;
  //     object1.loan_tender_status = openSearchData?.loan_tender_status;
  //     object1.loan_tender_deadline = openSearchData?.loan_tender_deadline;
  //     object1.loan_tender_notes = openSearchData?.loan_tender_notes;
  //     object1.cust_data_city = openSearchData?.cust_data_city;
  //     object1.status = openSearchData?.status;
  //     object1.loan_tender_id = openSearchData?.loan_tender_id;
  //     object1.cust_data_manager_name = openSearchData?.cust_data_manager_name;
  //     object1.hm_comment = openSearchData?.hm_comment;
  //     object1.accountant_name = openSearchData?.accountant_name;
  //     object1.created_by = openSearchData?.created_by;
  //     object1.sort = openSort ? "desc" : "asc";
  //     object1.sort_by = openSearchData.sort_by;
  //     object1.loan_tender_status = "open";
  //     object1.size = -1;
  //     const getOpenTenderCall = TenderServices.getAllOpenTender(object1);

  //     let object2: any = {};
  //     object2.loan_data_priority = closeSearchData?.loan_data_priority;
  //     object2.loan_data_customerid = closeSearchData?.loan_data_customerid;
  //     object2.loan_data_agreement = closeSearchData?.loan_data_agreement;
  //     object2.loan_data_customername = closeSearchData?.loan_data_customername;
  //     object2.loan_data_name = closeSearchData?.loan_data_name;
  //     object2.loan_data_loan_value = closeSearchData?.loan_data_loan_value;
  //     object2.loan_data_margin = closeSearchData?.loan_data_margin;
  //     object2.loan_data_bank_group = closeSearchData?.loan_data_bank_group;
  //     object2.loan_tender_status = closeSearchData?.loan_tender_status;
  //     object2.loan_tender_deadline = closeSearchData?.loan_tender_deadline;
  //     object2.loan_tender_notes = closeSearchData?.loan_tender_notes;
  //     object2.cust_data_city = closeSearchData?.cust_data_city;
  //     object2.status = closeSearchData?.status;
  //     object2.loan_tender_id = closeSearchData?.loan_tender_id;
  //     object2.cust_data_manager_name = closeSearchData?.cust_data_manager_name;
  //     object2.hm_comment = closeSearchData?.hm_comment;
  //     object2.accountant_name = closeSearchData?.accountant_name;
  //     object2.created_by = closeSearchData?.created_by;
  //     object2.sort = closeSort ? "desc" : "asc";
  //     object2.sort_by = closeSearchData.sort_by;
  //     object2.loan_tender_status = "close";
  //     object2.size = -1;
  //     const getCloseTenderCall = TenderServices.getAllOpenTender(object2);

  //     let object3: any = {};
  //     object3.loan_data_priority = dontSearchData?.loan_data_priority;
  //     object3.loan_data_customerid = dontSearchData?.loan_data_customerid;
  //     object3.loan_data_agreement = dontSearchData?.loan_data_agreement;
  //     object3.loan_data_customername = dontSearchData?.loan_data_customername;
  //     object3.loan_data_name = dontSearchData?.loan_data_name;
  //     object3.loan_data_loan_value = dontSearchData?.loan_data_loan_value;
  //     object3.loan_data_margin = dontSearchData?.loan_data_margin;
  //     object3.loan_data_bank_group = dontSearchData?.loan_data_bank_group;
  //     object3.loan_tender_status = dontSearchData?.loan_tender_status;
  //     object3.loan_tender_deadline = dontSearchData?.loan_tender_deadline;
  //     object3.loan_tender_notes = dontSearchData?.loan_tender_notes;
  //     object3.cust_data_city = dontSearchData?.cust_data_city;
  //     object3.status = dontSearchData?.status;
  //     object3.loan_tender_id = dontSearchData?.loan_tender_id;
  //     object3.cust_data_manager_name = dontSearchData?.cust_data_manager_name;
  //     object3.hm_comment = dontSearchData?.hm_comment;
  //     object3.accountant_name = dontSearchData?.accountant_name;
  //     object3.created_by = dontSearchData?.created_by;
  //     object3.sort = dontSort ? "desc" : "asc";
  //     object3.sort_by = dontSearchData.sort_by;
  //     object3.loan_tender_status = "dont_tender";
  //     object3.size = -1;
  //     const getDontTenderCall = TenderServices.getAllOpenTender(object3);

  //     try {
  //       let getOpenTender, getCloseTender, getDontTender;

  //       const [getOpenTenderRes, getCloseTenderRes, getDontTenderRes] =
  //         await Promise.all([
  //           getOpenTenderCall,
  //           getCloseTenderCall,
  //           getDontTenderCall,
  //         ]);

  //       setLoading(false);

  //       if (getOpenTenderRes) {
  //         getOpenTender = getOpenTenderRes?.data?.data;
  //       }

  //       if (getCloseTenderRes) {
  //         getCloseTender = getCloseTenderRes?.data?.data;
  //       }

  //       if (getDontTenderRes) {
  //         getDontTender = getDontTenderRes?.data?.data;
  //       }

  //       const dataObj = {
  //         getOpenTender,
  //         getCloseTender,
  //         getDontTender,
  //       };
  //       setTenderData(dataObj);
  //     } catch (e) {
  //       console.log(e);
  //     }
  //   };

  const getAllData = async () => {
    setLoading(true);

    //  OPEN
    let openObj: any = { ...openSearchData };
    openObj.loan_tender_status = "open";
    openObj.sort = openSort ? "desc" : "asc";
    openObj.sort_by = openSearchData.sort_by;
    // openObj.size = -1;
    openObj.page = openPageData.page;
    openObj.size = openPageData.size;

    // Save filters + sort to cookie
    cookies.set("tenders-open-filters", openObj, { path: "/" });

    // Remove empty values before sending to backend
    Object.keys(openObj).forEach((key) => {
      if (
        openObj[key] === "" ||
        openObj[key] === null ||
        openObj[key] === undefined
      ) {
        delete openObj[key];
      }
    });

    // CLOSE
    let closeObj: any = { ...closeSearchData };
    closeObj.loan_tender_status = "close";
    closeObj.sort = closeSort ? "desc" : "asc";
    closeObj.sort_by = closeSearchData.sort_by;
    // closeObj.size = -1;
    closeObj.page = closePageData.page;
    closeObj.size = closePageData.size;

    cookies.set("tenders-close-filters", closeObj, { path: "/" });
    Object.keys(closeObj).forEach((key) => {
      if (
        closeObj[key] === "" ||
        closeObj[key] === null ||
        closeObj[key] === undefined
      ) {
        delete closeObj[key];
      }
    });

    //DONT TENDER
    let dontObj: any = { ...dontSearchData };
    dontObj.loan_tender_status = "dont_tender";
    dontObj.sort = dontSort ? "desc" : "asc";
    dontObj.sort_by = dontSearchData.sort_by;
    // dontObj.size = -1;
    dontObj.page = dontPageData.page;
    dontObj.size = dontPageData.size;

    cookies.set("tenders-dont-filters", dontObj, { path: "/" });
    Object.keys(dontObj).forEach((key) => {
      if (
        dontObj[key] === "" ||
        dontObj[key] === null ||
        dontObj[key] === undefined
      ) {
        delete dontObj[key];
      }
    });

    try {
      const [openRes, closeRes, dontRes] = await Promise.all([
        TenderServices.getAllOpenTender(openObj),
        TenderServices.getAllOpenTender(closeObj),
        TenderServices.getAllOpenTender(dontObj),
      ]);
      setOpenTotalRecords(openRes?.data?.total_records || 0);
      setOpenTotalPages(openRes?.data?.total_pages || 0);
      setCloseTotalRecords(closeRes?.data?.total_records || 0);
      setCloseTotalPages(closeRes?.data?.total_pages || 0);

      setDontTotalRecords(dontRes?.data?.total_records || 0);
      setDontTotalPages(dontRes?.data?.total_pages || 0);

      setTenderData({
        getOpenTender: openRes?.data?.data || [],
        getCloseTender: closeRes?.data?.data || [],
        getDontTender: dontRes?.data?.data || [],
      });
    } catch (error) {
      console.error("Error fetching tenders:", error);
      message.error("Failed to load tender data");
    } finally {
      setLoading(false);
    }
  };
  const handleOk = () => {
    setConfirmLoading(true);
    TenderServices.revertTender(revertData?.loan_tender_id)
      .then((response: any) => {
        if (response?.data?.code === 500) {
          message.error(
            response?.data?.msg
              ? intl.formatMessage({
                  id: convertToObjectKeyString(response?.data?.msg),
                })
              : "There was some error during the process"
          );
          setOpen(false);
        }
        if (response?.data?.code === 200) {
          getAllData();
          setOpen(false);
        }
        setConfirmLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setConfirmLoading(false);
      });
  };

  const handleCancelPop = () => {
    setOpen(false);
  };

  const handleEdit = (val: any) => {
    setEditOpen(true);
    setEditValue({
      loan_tender_updated_at: val?.loan_tender_updated_at,
      loan_tender_notes: val?.loan_tender_notes,
      loan_tender_deadline: val?.loan_tender_deadline,
      loan_tender_status: val?.loan_tender_status,
      loan_tender_id: val?.loan_tender_id,
    });
  };

  const handleRevert = (val: any) => {
    setOpen(true);
    setRevertData(val);
  };

  const onFinishDontTender = (value: any) => {
    setConfirmLoading(true);
    const object = {
      loan_tender_status: value?.loan_tender_status,
      loan_tender_notes: value?.loan_tender_notes,
      loan_tender_deadline:
        value?.loan_tender_deadline === null
          ? value?.loan_tender_deadline
          : moment(value?.loan_tender_deadline).format("YYYY-MM-DD"),
    };
    TenderServices.updateTender(editValue?.loan_tender_id, object)
      .then((response: any) => {
        if (response?.data?.code === 200) {
          getAllData();
          setEditOpen(false);
          message.success(
            intl.formatMessage({
              id: convertToObjectKeyString("tender_edited_successfully"),
            })
          );
        }
        setConfirmLoading(false);
      })
      .catch((err: any) => {
        console.log(err);
        setConfirmLoading(false);
      });
  };

  const onNotesChange = (event: any) => {
    setEditValue({ ...editValue, loan_tender_notes: event.target.value });
  };

  const reTenderLoanData = async (formData: any) => {
    formData.created_by = UserService.getUserFullName();
    const newFormData = { ...reTenderData, ...formData };

    const getAllDataCall = await HousingCompanyService.saveTender(newFormData);
    if (getAllDataCall?.data?.code === 500) {
      message.error(
        intl.formatMessage({
          id: convertToObjectKeyString(getAllDataCall?.data?.msg),
        })
      );
    } else if (getAllDataCall?.data?.code === 200) {
      message.success(
        intl.formatMessage({
          id: convertToObjectKeyString(getAllDataCall?.data?.msg),
        })
      );
      setReTenderModalOpen(false);
      getAllData();
    }
  };

  const onSelectReTender = (data: any) => {
    Modal.confirm({
      title: intl.formatMessage({
        id: convertToObjectKeyString(
          "are_you_sure_you_want_to_re_tender_this_loan"
        ),
      }),
      icon: <ExclamationCircleFilled />,
      okText: intl.formatMessage({ id: convertToObjectKeyString("Yes") }),
      okButtonProps: { className: "cu-btn-green rounded" },
      cancelText: intl.formatMessage({
        id: convertToObjectKeyString("Cancel"),
      }),
      cancelButtonProps: { className: "cu-border-green cu-text-green rounded" },
      onOk() {
        let objData: any = {};
        objData.loan_data_credit_id = data?.loan_data_credit_id;
        objData.loan_data_name = data?.loan_data_name;
        objData.loan_tender_status = "potential";
        objData.re_tender = true;
        objData.customer_id = data?.LOAN_DATA?.CUST_DATA?.customer_id;
        setReTenderData(objData);
        setReTenderModalOpen(true);
      },
      onCancel() {
        // console.log('Cancel');
      },
    });
  };

  return (
    <>
      <Spin spinning={loading}>
        <TendersHeading props={props} />
        <Card className="rounded-0">
          <Card.Body className="p-0">
            <OpenLoanTenderingCase
              tenderData={tenderData}
              handleEdit={handleEdit}
              handleRevert={handleRevert}
              getAllData={getAllData}
              setOpenSearchData={setOpenSearchData}
              openSearchData={openSearchData}
              openSort={openSort}
              setOpenSort={setOpenSort}
              setDeadlineRequired={setDeadlineRequired}
              setNotesRequired={setNotesRequired}
              openPageData={openPageData}
              setOpenPageData={setOpenPageData}
              openTotalRecords={openTotalRecords}
              openTotalPages={openTotalPages}
            />
            <CloseLoanTenderingCase
              tenderData={tenderData}
              setCloseSearchData={setCloseSearchData}
              closeSearchData={closeSearchData}
              closeSort={closeSort}
              setCloseSort={setCloseSort}
              handleEdit={handleEdit}
              setDeadlineRequired={setDeadlineRequired}
              setNotesRequired={setNotesRequired}
              onSelectReTender={onSelectReTender}
              closePageData={closePageData}
              setClosePageData={setClosePageData}
              closeTotalRecords={closeTotalRecords}
              closeTotalPages={closeTotalPages}
            />
            <DontTenderTenderingCases
              tenderData={tenderData}
              handleEdit={handleEdit}
              handleRevert={handleRevert}
              setDontSearchData={setDontSearchData}
              dontSearchData={dontSearchData}
              dontSort={dontSort}
              setDontSort={setDontSort}
              setDeadlineRequired={setDeadlineRequired}
              setNotesRequired={setNotesRequired}
              dontPageData={dontPageData}
              setDontPageData={setDontPageData}
              dontTotalRecords={dontTotalRecords}
              dontTotalPages={dontTotalPages}
            />
          </Card.Body>
        </Card>
      </Spin>
      <Modal
        title={TranslateString("edit")}
        open={editOpen}
        footer={false}
        destroyOnClose
        closable={false}
      >
        <Form
          requiredMark={false}
          name={"Edit"}
          onFinish={onFinishDontTender}
          layout="vertical"
          initialValues={{
            loan_tender_updated_at: moment(editValue?.loan_tender_updated_at),
            loan_tender_status: editValue?.loan_tender_status,
            loan_tender_notes: editValue?.loan_tender_notes,
            loan_tender_deadline: editValue?.loan_tender_deadline
              ? moment(editValue?.loan_tender_deadline)
              : moment(new Date()),
          }}
        >
          <Form.Item
            label={
              <>
                <span>{TranslateString("status")}</span>
                <span className="text-danger">*</span>
              </>
            }
            name="loan_tender_status"
            rules={[
              {
                required: true,
                message: TranslateString("please_select_status"),
              },
            ]}
            className="mb-0"
          >
            <Select
              placeholder={TranslateString("select")}
              className="w-100 mb-1"
              allowClear
              options={[
                ...TenderEditStatus.map(({ value, label }) => {
                  return {
                    value: value,
                    label: intl.formatMessage({
                      id: convertToObjectKeyString(value),
                    }),
                  };
                }),
              ]}
              onChange={(val) => {
                setEditValue({ ...editValue, loan_tender_status: val });
              }}
            />
          </Form.Item>
          {/* <Form.Item
                        label="Loan tender last updated at"
                        name="loan_tender_updated_at"
                    >
                        <DatePicker
                            disabled
                            format={"DD/MM/YYYY"}
                            className="w-100"
                        />
                    </Form.Item> */}
          <ConfigProvider locale={intl.locale === "en" ? localeEN : localeFI}>
            <Form.Item
              label={
                <>
                  <span>{TranslateString("deadline")} </span>
                  {deadlineRequired && <span className="text-danger">*</span>}
                </>
              }
              name="loan_tender_deadline"
              rules={[
                {
                  required: deadlineRequired,
                  message: TranslateString("please_select_deadline"),
                },
              ]}
            >
              <DatePicker
                format={"DD.MM.YYYY"}
                className="w-100"
                onChange={(val) => {
                  setEditValue({ ...editValue, loan_tender_deadline: val });
                }}
              />
            </Form.Item>
          </ConfigProvider>

          <Form.Item
            className="mb-0"
            label={
              <>
                <span>{TranslateString("notes")}</span>
                {notesRequired && <span className="text-danger">*</span>}
              </>
            }
            name="loan_tender_notes"
            rules={[
              {
                required: notesRequired,
                message: TranslateString("please_enter_notes"),
              },
              {
                validator: (_, value) => {
                  if (value && value.includes(";")) {
                    return Promise.reject("Semicolon (;) is not allowed");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.TextArea
              rows={4}
              placeholder={TranslateString("maximum_500_charecter")}
              maxLength={500}
              onChange={(e) => onNotesChange(e)}
            />
          </Form.Item>
          {editValue?.loan_tender_notes?.length > 0 && (
            <Form.Item>
              {`${editValue?.loan_tender_notes?.length}/500`}
            </Form.Item>
          )}
          <div className="d-flex justify-content-end mt-2">
            <Button
              type="reset"
              className="btn btn-sm btn-secondary px-4"
              onClick={() => {
                setEditOpen(false);
              }}
            >
              {TranslateString("cancel")}
            </Button>
            &nbsp;
            <Button
              type="submit"
              className="btn btn-sm btn-light px-3 cu-btn-green"
              disabled={confirmLoading}
            >
              {confirmLoading
                ? TranslateString("Please Wait")
                : TranslateString("submit")}
            </Button>
          </div>
        </Form>
      </Modal>
      <Modal
        title=""
        open={open}
        onOk={handleOk}
        okButtonProps={{ className: "cu-bg-green rounded" }}
        okText={TranslateString("yes")}
        cancelText={TranslateString("no")}
        cancelButtonProps={{ className: "cu-bg-green rounded" }}
        confirmLoading={confirmLoading}
        onCancel={handleCancelPop}
      >
        <p className="h5">
          {TranslateString(
            "are_you_sure_you_want_to_move_this_loan_back_to_the_target_group"
          )}
        </p>
      </Modal>

      <Modal
        open={reTenderModalOpen}
        destroyOnClose
        footer={false}
        onCancel={() => setReTenderModalOpen(false)}
      >
        <Form
          requiredMark={false}
          onFinish={reTenderLoanData}
          layout="vertical"
          initialValues={{}}
        >
          <Form.Item
            label={
              <>
                <span>
                  {intl.formatMessage({
                    id: convertToObjectKeyString("Reason"),
                  })}
                </span>
                <span className="text-danger">*</span>
              </>
            }
            name="loan_tender_notes"
            rules={[
              {
                required: true,
                message: intl.formatMessage({
                  id: convertToObjectKeyString("Please input your Reason!"),
                }),
              },
            ]}
            className="mb-1"
          >
            <Input.TextArea />
          </Form.Item>
          <div className="d-flex justify-content-end">
            <Button
              type="reset"
              className="btn btn-sm bg-secondary px-4 border-secondary"
              onClick={props.handleReset}
            >
              {TranslateString("reset")}
            </Button>
            &nbsp;
            <Button type="submit" className="btn btn-sm cu-btn-green px-3">
              {TranslateString("Submit")}
            </Button>
          </div>
        </Form>
      </Modal>
    </>
  );
}
export default Tenders;
